import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SortDownLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5 8h8M5 12h6M5 16h4" }), _jsx("path", { stroke: "currentColor", d: "m19 18 3-3m-3 3-3-3m3 3V6" })] }) });
}
const SortDownLight = forwardRef(_SortDownLight);
export { SortDownLight };
